import _ from 'lodash';
import React from 'react';
import T from 'prop-types';
import { ThemeProvider } from 'styled-components';

import AwaySignIcon from 'components/lib/icons/away_sign_icon';
import connect from 'components/lib/connect';
import ReturnFromAway from 'actions/agent_status/return_from_away';
import SelectIdleReason from 'actions/agent_status/select_idle_reason';
import theme from 'scripts/presentation/themes/default';
import UserAuthLayout from './lib/user_auth_layout';
import UserButton from './lib/user_button';
import UserSurvey from './user_survey';

export const UserAwayPage = ({ awayReasonId, onReturnClick }) => {
  return (
    <ThemeProvider theme={theme}>
      <UserAuthLayout
        className="userAwayPage-container"
        displayLogo
        image={
          <React.Fragment>
            <UserSurvey />
            <AwaySignIcon />
          </React.Fragment>
        }
        layoutClassName="userAwayPage"
        title="We'll be here when you get back"
      >
        <UserButton
          className="userAwayPage-button userAuthLayout-button"
          onClick={() => {
            onReturnClick(awayReasonId);
          }}
        >
          I'm back
        </UserButton>
      </UserAuthLayout>
    </ThemeProvider>
  );
};

UserAwayPage.propTypes = {
  awayReasonId: T.string,
  onReturnClick: T.func.isRequired,
};

const mapStateToProps = context => {
  const agentStatus = context.getProvider('agentStatus').get();
  const awayReasonId = _.get(agentStatus, 'status.reasonId');

  return { awayReasonId };
};

const mapExecuteToProps = executeAction => {
  return {
    onReturnClick: awayReasonId => {
      if (awayReasonId) {
        executeAction(ReturnFromAway);
      } else {
        executeAction(SelectIdleReason);
      }
    },
  };
};

export default connect(mapStateToProps, mapExecuteToProps)(UserAwayPage);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/user/user_away_page.jsx